import { SiweMessage, generateNonce } from "siwe";
import {
  collection,
  addDoc,
  getDocs,
  query,
  orderBy,
} from "firebase/firestore";
import { mainnet, polygon, polygonMumbai, sepolia } from "viem/chains";

import { db } from "../config/fireBaseConfig";
const tvkEthAbi = require(`abi/${process.env.REACT_APP_ENV}/ethereum/tvkAbi`);
const swapEthAbi = require(`abi/${process.env.REACT_APP_ENV}/ethereum/swapAbi`);
const vanryEthAbi = require(`abi/${process.env.REACT_APP_ENV}/ethereum/vanryAbi`);
const tvkPolygonAbi = require(`abi/${process.env.REACT_APP_ENV}/polygon/tvkAbi`);
const swapPolygonAbi = require(`abi/${process.env.REACT_APP_ENV}/polygon/swapAbi`);
const vanryPolygonAbi = require(`abi/${process.env.REACT_APP_ENV}/polygon/vanryAbi`);

const domain = window.location.host;
const origin = window.location.origin;

export const envChains = JSON.parse(process.env.REACT_APP_CHAIN) ?? [];
// export const isSwapRouteEnabled = JSON.parse(
//   process.env.REACT_APP_SWAP_ROUTE_ENABLED
// );
export const isSwapRouteEnabled = true;

export const ENV = {
  DEV: "DEV",
  STAGING: "STAGING",
  PRE_PROD: "PRE_PROD",
  PROD: "PROD",
};
export const status = {
  APPROVED_ALLOWANCE: "APPROVED_ALLOWANCE",
  SWAPPED: "SWAPPED",
  PENDING: "PENDING",
  SUCCESS: "SUCCESS",
  FAIL: "FAIL",
};

export const walletIcon = {
  metaMask: process.env.REACT_APP_S3_IMAGE_PATH + "metamaskBtn.png",
  walletConnect: process.env.REACT_APP_S3_IMAGE_PATH + "connectBtn.png",
  coinbaseWallet: process.env.REACT_APP_S3_IMAGE_PATH + "coinbaseBtn.png",
};

export const createSiweMessage = (address, statement, chainId) => {
  const message = new SiweMessage({
    domain,
    address,
    statement,
    uri: origin,
    version: "1",
    chainId,
    nonce: generateNonce(),
  });
  return message.prepareMessage();
};

export const verifySignature = async (message, signature) => {
  const siweMsg = new SiweMessage(message);
  try {
    await siweMsg.verify({ signature });
    return true;
  } catch (error) {
    return false;
  }
};

export const getTransactionUrl = (hash, network) => {
  let url = "";
  const env = process.env.REACT_APP_ENV;
  if (env === ENV.STAGING) {
    url =
      envChains[0] === network
        ? process.env.REACT_APP_POLYGON_SCAN_URL
        : process.env.REACT_APP_ETHEREUM_SCAN_URL;
  } else {
    url =
      envChains[0] === network
        ? process.env.REACT_APP_POLYGON_SCAN_URL
        : process.env.REACT_APP_ETHEREUM_SCAN_URL;
  }
  return hash ? `${url}${hash}` : url;
};

export const twoDecimalPlaces = (val) => {
  if (val) {
    const isDecimal = `${val}`.split(".")[1] ? true : false;
    if (isDecimal) {
      const afterDotVal = `${val}`.split(".")[1]?.slice(0, 2);
      const beforeDotVal = `${val}`.split(".")[0];
      return `${Number(beforeDotVal).toLocaleString()}.${afterDotVal}`;
    } else {
      return Number(val).toLocaleString();
    }
  } else {
    return 0;
  }
};
export const formatNumberValue = (val) => {
  if (val) {
    const isDecimal = `${val}`.split(".")[1] ? true : false;
    if (isDecimal) {
      const afterDotVal = `${val}`.split(".")[1];
      const beforeDotVal = `${val}`.split(".")[0];
      return `${Number(beforeDotVal).toLocaleString()}.${afterDotVal}`;
    } else {
      return Number(val).toLocaleString();
    }
  } else {
    return 0;
  }
};

export const getTruncatedAddress = (str) => {
  if (str && str !== "") {
    return str?.slice(0, 5) + str?.slice(-8).replace(/.(?=...)/g, "*");
  }
  return "";
};

export const getDecimalLength = (value) => {
  if (value.includes(".")) {
    return value.split(".")[1]?.length;
  }
  return 0;
};

export const handleKeyDown = (e) => {
  // List of allowed keys apart from numbers
  const allowedKeys = ["Backspace", "ArrowRight", "ArrowLeft", "Tab", "Delete"];

  // If it's an allowed key, let it through

  if (allowedKeys.includes(e.key)) {
    return;
  }

  // Only allow numbers and point, prevent any other character

  const regex = /[^0-9.]/;
  if (regex.test(e.key)) {
    e.preventDefault();
  }
};

export const getChainId = (selectedNetwork) => {
  let chainId =
    process.env.REACT_APP_ENV === ENV.STAGING ? sepolia.id : mainnet.id;
  if (selectedNetwork === 80001) {
    chainId = polygonMumbai?.id;
  } else if (selectedNetwork === 11155111) {
    chainId = sepolia?.id;
  } else if (selectedNetwork === 137) {
    chainId = polygon?.id;
  } else if (selectedNetwork === 1) {
    chainId = mainnet?.id;
  }
  return chainId;
};

export const pageRefresh = () => {
  document.location.reload(true);
};

export const getContractAndAbi = (chainId) => {
  let tvkTokenContract = null;
  let swapContract = null;
  let vanryContract = null;
  let tvkTokenAbi = null;
  let vanryAbi = null;
  let swapAbi = null;
  if (chainId === envChains[1]) {
    tvkTokenContract = process.env.REACT_APP_ETHEREUM_TVK_TOKEN_CONTRACT;
    swapContract = process.env.REACT_APP_ETHEREUM_TVK_SWAP_CONTRACT;
    vanryContract = process.env.REACT_APP_ETHEREUM_VANRY_CONTRACT;
    tvkTokenAbi = tvkEthAbi;
    swapAbi = swapEthAbi;
    vanryAbi = vanryEthAbi;
  } else {
    tvkTokenContract = process.env.REACT_APP_POLYGON_TVK_TOKEN_CONTRACT;
    swapContract = process.env.REACT_APP_POLYGON_TVK_SWAP_CONTRACT;
    vanryContract = process.env.REACT_APP_POLYGON_VANRY_CONTRACT;
    tvkTokenAbi = tvkPolygonAbi;
    swapAbi = swapPolygonAbi;
    vanryAbi = vanryPolygonAbi;
  }
  return {
    tvkTokenAbi,
    tvkTokenContract,
    swapAbi,
    swapContract,
    vanryAbi,
    vanryContract,
  };
};

export const AddTrxToDB = async (txId, to, from, tvk, txType, chainId) => {
  const currentDate = new Date();
  const utcDate = currentDate.setUTCDate(currentDate.getUTCDate());
  const id = from;
  const userTransactionJson = {
    txId,
    to,
    from,
    date: utcDate,
    tvk,
    txType,
    chainId,
  };

  try {
    await addDoc(
      collection(db, "vanar_swap", id, "transactions"),
      userTransactionJson
    );
  } catch (e) {}
};

export const FetchUserTrxData = async (address, selectedNetwork) => {
  try {
    const colRef = query(
      collection(db, "vanar_swap", address, "transactions"),
      orderBy("date", "desc")
    );
    const querySnapshot = await getDocs(colRef);
    let user_data = [];
    querySnapshot?.forEach((doc) => {
      // if (doc.data()?.txType === "SwapToken" && doc.data()?.chainId === selectedNetwork ) {
      if (doc.data()?.txType === "SwapToken") {
        user_data.push({
          id: doc.id,
          ...doc.data(),
        });
      }
    });
    return user_data;
  } catch (error) {}
};

export const formatUTC = (utc) => {
  const date = new Date(utc);

  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based in JS
  const year = String(date.getUTCFullYear()).slice(2);

  const formattedDate = `${day}/${month}/${year}`;
  return formattedDate;
};

export const addVanryTokenToMetamask = async (contractAddress, provider) => {
  try {
    await provider.request({
      method: "wallet_watchAsset",
      params: {
        type: "ERC20",
        options: {
          address: contractAddress,
          symbol: "VANRY",
          decimals: 18,
          image: "https://assets-cdn.bimtvist.com/images/swap/logo.svg",
        },
      },
    });
    return { status: "success" };
  } catch (error) {
    return { status: "fail", payload: error };
  }
};

export const copyToClipboard = async (value) => {
  try {
    await navigator.clipboard.writeText(value);
    return "success";
  } catch (error) {
    return "fail";
  }
};

export const handleDeepLink = () => {
  const a = document.createElement("a");
  a.href = process.env.REACT_APP_DEEP_LINK;
  a.click();
};

